function SourceReport() {
    return (
      <>
        <div className="font-bold text-lg mb-16">SourceReport</div>
      </>
    );
  }
  
  export default SourceReport;